module.exports = __webpack_public_path__ + "img/logo.78a29ba5.gif";